import { render, staticRenderFns } from "./microphone.vue?vue&type=template&id=d8c6ff4c&"
import script from "./microphone.vue?vue&type=script&lang=js&"
export * from "./microphone.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d8c6ff4c')) {
      api.createRecord('d8c6ff4c', component.options)
    } else {
      api.reload('d8c6ff4c', component.options)
    }
    module.hot.accept("./microphone.vue?vue&type=template&id=d8c6ff4c&", function () {
      api.rerender('d8c6ff4c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/icons/svg/microphone.vue"
export default component.exports